import { render, staticRenderFns } from "./SAASRecursionTree2.vue?vue&type=template&id=9892cd6e&scoped=true"
import script from "./SAASRecursionTree2.vue?vue&type=script&lang=js"
export * from "./SAASRecursionTree2.vue?vue&type=script&lang=js"
import style0 from "./SAASRecursionTree2.vue?vue&type=style&index=0&id=9892cd6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9892cd6e",
  null
  
)

export default component.exports